<template>
  <div>
    <LvFlexBox
      v-if="title || $scopedSlots.titleRight"
      noWrap
      alignItems="center"
      justifyContent="space-between"
      class="mb-8"
    >
      <LvText v-if="title" h4 bold>{{ title }}</LvText>
      <slot name="titleRight" />
    </LvFlexBox>
    <draggable
      tag="ul"
      :list="list"
      :group="{ name: 'g1' }"
      :emptyInsertThreshhold="500"
      filter=".lv-state-sort__no-drag"
      :preventOnFilter="false"
      class="lv-state-sort ml-16"
      @change="$_onChange($event)"
      @start="$_onDragStart"
      @end="$_onDragEnd"
      :move="$_onDragMove"
    >
      <li v-for="item in list" :key="item.id">
        <SortingChecklistQuestion
          :title="labelKey ? `${item[labelKey]} ${item[titleKey]}` : item[titleKey]"
          class="lv-state-sort__question mb-8"
        >
          <template v-if="$scopedSlots.right" v-slot:right>
            <div class="lv-state-sort__no-drag">
              <slot name="right" :item="item" />
            </div>
          </template>
        </SortingChecklistQuestion>
        <LvStateSort
          v-if="item.children"
          :list="item.children"
          :class="{ 'py-10': item.children.length > 0, 'py-5': item.children.length === 0 }"
        />
      </li>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable';

const DRAG_SCROLL_EDGE = 72;
const DRAG_SCROLL_SPEED = 12;

export default {
  components: {
    draggable,
  },
  inject: {
    getPopupScrollContainer: { default: null },
    scrollPopupBy: { default: null },
    getPopupScrollBottomInset: { default: null },
  },
  props: {
    title: {
      type: String,
    },
    list: {
      type: Array,
    },
    titleKey: {
      type: String,
      default: 'name',
    },
    labelKey: {
      type: String,
    },
  },
  data() {
    return {
      dragScrollActive: false,
      dragScrollRafId: null,
      dragPointerY: null,
    };
  },
  beforeDestroy() {
    this.$_stopDragScroll();
  },
  methods: {
    $_onChange($event) {
      this.$emit('change', $event);
    },
    $_onDragMove(evt, originalEvent) {
      if (this.getPopupScrollContainer) {
        const e = originalEvent || evt;
        if (e) {
          const clientY = e.clientY != null ? e.clientY : (e.touches && e.touches[0] && e.touches[0].clientY);
          if (clientY != null) {
            this.dragPointerY = clientY;
          }
        }
      }
      return true;
    },
    $_onDragStart() {
      if (!this.getPopupScrollContainer || !this.scrollPopupBy) return;
      this.dragScrollActive = true;
      this.documentPointerMoveHandler = (e) => {
        const y = e.clientY != null ? e.clientY : (e.touches && e.touches[0] && e.touches[0].clientY);
        if (y != null) {
          this.dragPointerY = y;
        }
      };
      document.addEventListener('mousemove', this.documentPointerMoveHandler);
      document.addEventListener('touchmove', this.documentPointerMoveHandler, { passive: true });
      document.addEventListener('dragover', this.documentPointerMoveHandler);
      this.$_tickDragScroll();
    },
    $_onDragEnd() {
      this.$_stopDragScroll();
    },
    $_stopDragScroll() {
      this.dragScrollActive = false;
      if (this.dragScrollRafId != null) {
        cancelAnimationFrame(this.dragScrollRafId);
        this.dragScrollRafId = null;
      }
      if (this.documentPointerMoveHandler) {
        document.removeEventListener('mousemove', this.documentPointerMoveHandler);
        document.removeEventListener('touchmove', this.documentPointerMoveHandler);
        document.removeEventListener('dragover', this.documentPointerMoveHandler);
        this.documentPointerMoveHandler = null;
      }
    },
    $_getScrollEdgeBounds(scrollEl) {
      const rect = scrollEl.getBoundingClientRect();
      const bottomInset = this.getPopupScrollBottomInset ? this.getPopupScrollBottomInset() : 0;
      return {
        top: rect.top,
        bottom: rect.top + scrollEl.clientHeight - bottomInset,
      };
    },
    $_tickDragScroll() {
      if (!this.dragScrollActive) return;

      const scrollEl = this.getPopupScrollContainer();
      if (
        scrollEl
        && this.dragPointerY != null
        && scrollEl.scrollHeight > scrollEl.clientHeight
      ) {
        const { top, bottom } = this.$_getScrollEdgeBounds(scrollEl);
        if (this.dragPointerY < top + DRAG_SCROLL_EDGE) {
          this.scrollPopupBy(-DRAG_SCROLL_SPEED);
        } else if (this.dragPointerY > bottom - DRAG_SCROLL_EDGE) {
          this.scrollPopupBy(DRAG_SCROLL_SPEED);
        }
      }

      this.dragScrollRafId = requestAnimationFrame(() => {
        this.$_tickDragScroll();
      });
    },
  },
};
</script>
